interface CircleCheckMarkSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CircleCheckMarkSVG = ({ color, style }: CircleCheckMarkSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
  >
    <path
      d="M4.125 16.5C4.125 23.3345 9.66548 28.875 16.5 28.875C23.3345 28.875 28.875 23.3345 28.875 16.5C28.875 9.66548 23.3345 4.125 16.5 4.125C13.3305 4.125 10.4394 5.31652 8.25 7.27606M6.875 4.125V8.25C6.875 9.00939 7.49061 9.625 8.25 9.625H12.375M20.625 13.75L15.6111 18.7639C15.3427 19.0323 14.9073 19.0323 14.6389 18.7639L12.375 16.5"
      stroke={color}
      strokeWidth="2.75"
      strokeLinecap="round"
    />
  </svg>
);

export default CircleCheckMarkSVG;
